export default "__VITE_ASSET__BRp8Ithq__"